<template>
  <div class="payload-button other">
    <table>
      <tr>
        <td class="fix-width"><div class="logo-small"></div></td>
        <td>
          <div class="message">
            <div>{{ conversation.message.payload.message }}</div>
            <div
              v-for="(button, key) in conversation.message.payload.buttons"
              v-bind:key="key"
              class="element"
              v-on:click="handleButton(button)"
            >
              {{ button.title }}
            </div>
          </div>
          <span class="time">{{
            conversation.createdAt | timeChatFormat
          }}</span>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  name: 'PayloadButton',
  props: {
    conversation: Object
  },
  methods: {
    handleButton(button) {
      return this.$parent.handleButton(button)
    }
  }
}
</script>
